module.exports = __webpack_public_path__ + "b60abfe2f50f812c106d5f1ea71bb8d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/accordion.png
// module id = 1220
// module chunks = 0